// Function to convert height in inches to feet and inches
const convertInchesToFeetAndInches = (heightInInches) => {
	const feet = Math.floor(heightInInches / 12);
	const inches = heightInInches % 12;
	return `${feet}' ${inches}"`;
};

export default convertInchesToFeetAndInches;
